import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage'; // Import LandingPage
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import CompleteInfo from './components/CompleteInfo';
import './App.css';
import Tool2 from './components/canine-teeth/ToolCanineTeeth';
import Tool1 from './components/i3m/ToolCanineTeeth';
import Tool3 from './components/carpal-bones/ToolCanineTeeth';
import Tool4 from './components/vertebral-body/ToolCanineTeeth';
import Tool5 from './components/european-formula/ToolCanineTeeth';
import Tool2AI from './components/canine-teeth-ai/ToolCanineTeeth';
import Privacy from './components/PrivacyPolicy';
import PrivateRoute from './components/PrivateRoute';
import ReportGenerator from './components/i3m/ReportGenerator';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} /> {/* Set LandingPage as home */}
        <Route path="/login" element={<Login />} /> {/* Adjusted path */}
        <Route path="/register" element={<Register />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/complete-info"
          element={

              <CompleteInfo />

          }
        />
        {/* Define routes for tools */}
        <Route
          path="/tool1"
          element={
            <PrivateRoute>
              <Tool1 />
            </PrivateRoute>
          }
        />
        <Route
          path="/tool2"
          element={
            <PrivateRoute>
              <Tool2 />
            </PrivateRoute>
          }
        />
        <Route
          path="/tool2-ai"
          element={
            <PrivateRoute>
              <Tool2AI />
            </PrivateRoute>
          }
        />
        <Route
          path="/tool3"
          element={
            <PrivateRoute>
              <Tool3 />
            </PrivateRoute>
          }
        />
        <Route
          path="/tool4"
          element={
            <PrivateRoute>
              <Tool4 />
            </PrivateRoute>
          }
        />
        <Route
          path="/tool5"
          element={
            <PrivateRoute>
              <Tool5 />
            </PrivateRoute>
          }
        />
        <Route
          path="/report-generator-i3m"
          element={
            <PrivateRoute>
              <ReportGenerator />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
